import { resolver } from "@msuite/ui/libs/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal, type ModalProps } from "@msuite/ui/modal";
import { responseHandler } from "@msuite/ui/utils";
import {
	type ArticleProductTypeFormSchema,
	articleProductTypeFormSchema,
} from "@msuite/utils/schemas";
import { FormProvider, useForm } from "react-hook-form";
import { ArticleProductTypeForm } from "@/forms/article-product-type-form/article-product-type-form";
import { client } from "@/hono";

/** Props Interface */
interface AddArticleProductTypeModalProps extends ModalProps {
	onComplete?: () => Promise<void>;
	articleGroupId?: string;
}

export function AddArticleProductTypeModal({
	onClose,
	isOpen,
	onComplete,
	articleGroupId,
}: AddArticleProductTypeModalProps) {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useForm({
		resolver: resolver(articleProductTypeFormSchema),
		defaultValues: async () => {
			const defaultValues: Partial<ArticleProductTypeFormSchema> = {
				number: 0,
				autoGenerateNumber: true,
			};
			if (articleGroupId) defaultValues.articleGroupId = articleGroupId;
			return defaultValues as ArticleProductTypeFormSchema;
		},
		reValidateMode: "onSubmit",
	});

	/** Functions */
	async function handleOnSubmit(json: ArticleProductTypeFormSchema) {
		const response = await client.stock["article-product-types"].$post({
			json,
		});
		await responseHandler(response);
		await onComplete?.();
		onClose();
	}

	/** Render */
	return (
		<FormProvider {...methods}>
			<Modal
				title={t("stock.add_article_product_type")}
				isOpen={isOpen}
				onClose={onClose}
				onSubmit={methods.handleSubmit(handleOnSubmit)}
			>
				<Modal.Body>
					<ArticleProductTypeForm />
				</Modal.Body>
				<Modal.FooterForm />
			</Modal>
		</FormProvider>
	);
}
